import React, { useState } from "react";
import { filterJobs } from "../../core/data/jobs";
import { NO_NICHE_KEY, nicheNumbers } from "../../core/data/auditsPage";
import { AUDITS, INDUSTRY } from "../../core/theme/auditsTheme";
import useNicheRollup from "./useNicheRollup";
import useLiveJobs from "./useLiveJobs";
import useIndustrySelection from "./useIndustrySelection";
import useWebsiteSearch from "./useWebsiteSearch";
import IndustryBar from "./components/IndustryBar";
import IndustryAuditPanel from "./components/IndustryAuditPanel";
import AdaPanel from "./components/AdaPanel";
import MarketPanel from "./components/MarketPanel";
import AdvertisersPanel from "./components/AdvertisersPanel";

// The Audits page for accounts with Industry Audits (B2 stage 3): the
// industry tabs, then four panels for the selected industry. The Snapshots
// list shows straight away; the roll-up (useNicheRollup) fills the panels
// when it arrives, and a slow or failed roll-up never holds the list up.
// The selected industry lives in App (industry) and the page address.
export default function IndustryAuditsPage({
  agencyId, jobs, jobsLoading, jobSearch, setJobSearch, industry, setIndustry, reloadJobs,
  onOpenJob, onOpenPinned, onStopJob, onNewScan,
}) {
  const finished = useLiveJobs(jobs, reloadJobs);
  const rollupState = useNicheRollup(agencyId, true, finished);
  const { byKey, selected, current, tabs, more } = useIndustrySelection(jobs, rollupState, industry);
  const [websiteText, setWebsiteText] = useState("");
  const website = useWebsiteSearch(agencyId, websiteText);

  if (!current) {
    return (
      <div className={INDUSTRY.page}>
        {jobsLoading ? (
          <p className={AUDITS.message}>Loading snapshots…</p>
        ) : (
          <div className={AUDITS.message}>
            <p>No snapshots yet.</p>
            <button type="button" onClick={onNewScan} className={AUDITS.startButton}>Start search</button>
          </div>
        )}
      </div>
    );
  }

  const niche = nicheNumbers(current, rollupState.status === "ready" ? rollupState.rollup : null);
  const inIndustry = jobs.filter(j => (j.niche_id || NO_NICHE_KEY) === selected);

  return (
    <div className={INDUSTRY.page}>
      <IndustryBar tabs={tabs} more={more} byKey={byKey} selected={selected} onPick={setIndustry} onNewScan={onNewScan} />
      <div className={INDUSTRY.body}>
        <div className={INDUSTRY.column}>
          <IndustryAuditPanel industry={current} niche={niche} rollupState={rollupState} onNewScan={onNewScan} />
          <AdaPanel industry={current} niche={niche} />
        </div>
        <div className={INDUSTRY.column}>
          <MarketPanel
            industry={current} niche={niche} rollupState={rollupState}
            rows={filterJobs(inIndustry, jobSearch)} total={inIndustry.length} jobSearch={jobSearch} setJobSearch={setJobSearch}
            onOpenJob={onOpenJob} onStopJob={onStopJob}
          />
          <AdvertisersPanel jobs={jobs} text={websiteText} setText={setWebsiteText} website={website} onOpenPinned={onOpenPinned} />
        </div>
      </div>
    </div>
  );
}
